'use strict';
import template from './multiselect.html';
import controller from './multiselect.controller';

let multiselectComponent = () => {
  return {
    restrict: 'AE',
    scope: {
      selectedModel: '=',
      options: '=',
      extraSettings: '=',
      events: '=',
      searchFilter: '=?',
      translationTexts: '=',
      disabled: '='
    },
    template,
    controller
  };
};

export default multiselectComponent;


// WEBPACK FOOTER //
// ./app/common/multiselect/multiselect.component.js